/*
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 09:26:28
 * @LastEditors: whaoo
 * @LastEditTime: 2023-10-10 11:39:34
 */
import Vue from 'vue'
import Router from 'vue-router'
import BedList from '@/view/bed_list'
import BedDetail from '@/view/bed_detail'
import BindDevice from '@/view/bind_device'
import DeviceData from '@/view/device_data'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/bedList',
      name: 'bedList',
      component: BedList
    }, {
      path: '/bedDetail',
      name: 'bedDetail',
      component: BedDetail,
    },
    {
      path: "/bindDevice",
      name: 'bindDevice',
      component: BindDevice
    },
    {
      path: "/deviceData",
      name: 'deviceData',
      component: DeviceData
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js